import * as types from "../constants/actionsTypes";
import API from "../api";
import { authorizationError } from "./webInterface";

const api = new API();

export default (
  dispatch,
  apiMethod,
  url,
  body,
  actionType,
  payloadField,
  extraData,
  callback
) => {
  dispatch({
    type: types[`${actionType}_REQUEST`],
    extraField: extraData
  });

  return api[apiMethod](url, body)
    .then(response => {
		if (callback) {
			callback();
		}
      dispatch({
        type: types[`${actionType}_SUCCESS`],
        [payloadField]: response.data,
        extraField: extraData
      });
    })
    .catch(errorResponse => {
      let failure_type = types[`${actionType}_FAILURE`];
      let failure_data = errorResponse.error || errorResponse.data;
      if (window.location.port !== "3000") {
        window.Raven.captureException(failure_type, { extra: failure_data });
      }

      dispatch({
        type: failure_type,
        error: errorResponse.error || errorResponse.data
      });

      if (errorResponse.code && errorResponse.code === 401) {
        dispatch(authorizationError());
      }
    });
};



// WEBPACK FOOTER //
// ./actions/commonAction.js